import './polyfill'
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ContextProvider } from './store/Context';

ReactDOM.render(

    <ContextProvider>
        <App />
        <ToastContainer position='bottom-right' />
    </ContextProvider>

    ,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js